export type GoogleChatMessage = {
    cardsV2: {
        cardId: string;
        card: {
            header: {
                title: string;
                subtitle: string;
                imageUrl: string;
                imageType: 'SQUARE' | 'CIRCLE';
                imageAltText: string;
            };
            sections?: {
                header: string;
                widgets: {
                    textParagraph: {
                        text: string;
                    };
                }[];
            }[];
        };
    }[];
};

export type GoogleChatConfig = {
    key: string;
    token: string;
    space: string;
};

// When adding a new space here, you must do two things:
// 1. Add the space id to the utils/getGoogleChatConfig.ts file in the googleWorkspaceService lambda (you'll get a TS error if you don't)
// 2. In the AWS console, add the webhook *token* to the google-chat-secret-dev and google-chat-secret-prod secrets (the *key* is the same for all spaces and doesn't need to be modified)
// If you want messages to go to different places in dev and prod, just set the space ids/tokens accordingly
export type GoogleChatSpaceName = 'alarms' | 'support' | 'appFeed';
